import React, { useEffect } from 'react';
import { FaTelegramPlane } from "react-icons/fa";
import { Link } from "react-scroll"
import img from '../../assets/Code typing.gif'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { TypeAnimation } from 'react-type-animation';

const Banner = () => {

    useEffect(() => {
        AOS.init({ duration: 1500 });
    }, []);

    return (
        <div
            name="home"
            className="w-full bg-[#070716] md:h-screen"
        >
            <div className="max-w-sm lg:max-w-5xl mx-auto flex flex-col-reverse items-center justify-center h-full px-4 md:flex-row">
                <div className="flex flex-col justify-center h-full lg:w-1/2">
                    <p className='text-md text-white'>HEY THERE!</p>
                    <h2 className="text-3xl font-semibold text-white mb-3">
                        I'm <span className='text-4xl font-semibold text-cyan-500'>Saad,</span>
                    </h2>
                    <TypeAnimation

                        sequence={[
                            'An UI/UX Designer',
                            1000,
                            'A Frontend Developer',
                            1000,
                        ]}
                        speed={30} // Custom Speed from 1-99 - Default Speed: 40
                        style={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'white' }}
                        wrapper="span" // Animation will be rendered as a <span>
                        repeat={Infinity} // Repeat this Animation Sequence infinitely

                    />
                    <p className="text-gray-400 py-4 max-w-md">
                        Designing interactive applications and experiences on the web is truly a passion for me. I like to explore new tools & technologies. I love rock-music and travelling.

                    </p>

                    <div className='w-2/5 mx-auto lg:w-full'>
                        <Link
                            to="contact"
                            smooth={true}
                            duration={500}
                            className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
                        >
                            <span className="group-hover:rotate-180 duration-300">
                                <FaTelegramPlane size={25} className="mr-1" />
                            </span>
                            Hire Me
                        </Link>
                    </div>
                </div>

                <div className='lg:w-1/2' data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="1000">
                    <img
                        src={img}
                        alt="my profile"
                        className="rounded-2xl mx-auto w-full"
                    />
                </div>
            </div>
        </div>
    );
};

export default Banner;